import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import exportValue from "../../apiconfig";
import Left_panel from "../Left_panel";
import Sub_header from "../Sub_header";
import "../../components/loader.css";
import { useNavigate, useParams } from "react-router-dom";

const Edit_product = () => {
  const Cod = exportValue.COD_COMISSION;

  const navigate = useNavigate();
  const { product_id, carrier_id } = useParams();

  const [carrierList, setcarrierList] = useState([]);
  const [producttype, setproducttypeList] = useState([]);
  const [carrierdetail, setcarrierdetail] = useState({ list: [] });

  const [state, setState] = useState({
    product_name: "",
    carrier_id: carrier_id || "",
    mode: "",
    volumetric_weight: "",
    max_weight: "",
    additional_weight: "",
    product_type: "",
    parcel_type: "",
    order_type: "Forward",

    // Forward / COD
    cod_limit: "",
    cod_amount: "",
    cod_percentage: "",
    cod_invoice_limit: "",

    // Reverse / QC
    qc_enabled: false,
    qc_charge: "",
    qc_parameter_charge: "",

    error: {},
  });

  const [domesticmode, setdomesticmodeState] = useState({
    domestic: false,
  });

  const [internationalmode, setinternationalmodeState] = useState({
    international: false,
  });

  const [parceltype, setparceltypeState] = useState({
    parcel: false,
  });

  const [documenttype, setdocumenttypeState] = useState({
    document: false,
  });

  const [forwardtype, setforwardtypeState] = useState({
    forward: false,
  });

  const [reversetype, setreversetypeState] = useState({
    reverse: false,
  });

  const [rowstate, setRowState] = useState([]);

  const [errstate, seterrstate] = useState({
    err: "",
  });

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const [loading, setLoading] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);

    const homeSection = document.querySelector(".home-section");

    if (homeSection) {
      homeSection.classList.toggle("sidebar-closed");
    }
  };

  const Toast = Swal.mixin({
    toast: true,
    position: "bottom-end",
    showConfirmButton: false,
    timer: 3000,
  });

  // =========================================================
  // INITIAL LOAD
  // =========================================================

  useEffect(() => {
    getCarrierList();
    getProductTypeList(carrier_id);
    product_detail();
  }, []);

  // =========================================================
  // GET CARRIER LIST
  // =========================================================

  const getCarrierList = async () => {
    try {
      const full_api =
        exportValue.host +
        "/" +
        exportValue.version +
        "/" +
        exportValue.api +
        `/product_carrier_list`;

      const sendData = {
        dstatus: 1,
      };

      const res = await axios.post(full_api, sendData, {
        headers: exportValue.headers,
      });

      if (res.data?.status === true || res.data?.output) {
        setcarrierList(res.data.output || []);
      }
    } catch (error) {
      console.error("Carrier list error:", error);
    }
  };

  // =========================================================
  // GET PRODUCT TYPE / SERVICE LIST
  // =========================================================

  const getProductTypeList = async (carrierId) => {
    if (!carrierId) {
      return;
    }

    try {
      const full_api =
        exportValue.host +
        "/" +
        exportValue.version +
        "/" +
        exportValue.api +
        `/product_type`;

      const sendData = {
        carrier_id: carrierId,
      };

      const res = await axios.post(full_api, sendData, {
        headers: exportValue.headers,
      });

      setproducttypeList(res.data?.output || []);
    } catch (error) {
      console.error("Product type error:", error);
      setproducttypeList([]);
    }
  };

  // =========================================================
  // GET PRODUCT DETAIL
  // =========================================================

  const product_detail = async () => {
    try {
      setLoading(true);

      const full_api =
        exportValue.host +
        "/" +
        exportValue.version +
        "/" +
        exportValue.api +
        `/carrier_product_detail_api`;

      const sendData = {
        product_id: product_id,
        carrier_id: carrier_id,
      };

      console.log("Product detail request:", sendData);

      const res = await axios.post(full_api, sendData, {
        headers: exportValue.headers,
      });

      console.log("Product detail response:", res);

      if (!res.data || !res.data.output || res.data.output.length === 0) {
        Toast.fire({
          background: "rgb(231, 91, 75)",
          icon: "error",
          title: "Product details not found",
          color: "white",
        });

        return;
      }

      const product = res.data.output[0];

      // -----------------------------------------------------
      // WEIGHT RANGE
      // -----------------------------------------------------

      const apiWeightRange =
        Array.isArray(product.weight_range) && product.weight_range.length > 0
          ? product.weight_range
          : [
              {
                start_range: "0.00",
                end_range: "",
                buttonType: "add",
                error: {},
                err: {},
                err1: {},
                point: "",
              },
            ];

      const formattedWeightRange = apiWeightRange.map((item, index) => ({
        start_range:
          item.start_range !== undefined && item.start_range !== null
            ? String(item.start_range)
            : "",

        end_range:
          item.end_range !== undefined && item.end_range !== null
            ? String(item.end_range)
            : "",

        // Existing edit page does not allow editing
        // weight ranges, so these are only maintained
        // for consistency.
        buttonType: index === 0 ? "add" : "remove",

        error: {},
        err: {},
        err1: {},
        point: "",
      }));

      setRowState(formattedWeightRange);

      // -----------------------------------------------------
      // ORDER TYPE
      // -----------------------------------------------------

      const orderType =
        String(product.order_type || "Forward").toLowerCase() === "reverse"
          ? "Reverse"
          : "Forward";

      // -----------------------------------------------------
      // QC ENABLED
      // -----------------------------------------------------

      let qcEnabled =
        product.qc_enabled === true ||
        String(product.qc_enabled).toLowerCase() === "true" ||
        Number(product.qc_enabled) === 1 ||
        String(product.qc_enabled) === "1";

      /*
       * Backward compatibility:
       * If an older Reverse product was created before
       * qc_enabled existed, but it already has a QC charge,
       * treat it as QC enabled while editing.
       */
      if (
        orderType === "Reverse" &&
        product.qc_enabled === undefined &&
        Number(product.qc_charge || 0) > 0
      ) {
        qcEnabled = true;
      }

      // -----------------------------------------------------
      // SET MAIN STATE
      // -----------------------------------------------------

      setState({
        product_name: product.product_name || "",

        carrier_id: product.carrier_id || carrier_id || "",

        mode: product.mode || "",

        volumetric_weight:
          product.volumetric_weight !== undefined &&
          product.volumetric_weight !== null
            ? product.volumetric_weight
            : "",

        max_weight:
          product.max_weight !== undefined && product.max_weight !== null
            ? product.max_weight
            : "",

        additional_weight:
          product.additional_weight !== undefined &&
          product.additional_weight !== null
            ? product.additional_weight
            : "",

        product_type: product.product_type || "",

        parcel_type: product.parcel_type || "",

        order_type: orderType,

        // Forward / COD
        cod_limit:
          product.cod_limit !== undefined && product.cod_limit !== null
            ? product.cod_limit
            : "",

        cod_amount:
          product.cod_amount !== undefined && product.cod_amount !== null
            ? product.cod_amount
            : "",

        cod_percentage:
          product.cod_percentage !== undefined &&
          product.cod_percentage !== null
            ? product.cod_percentage
            : "",

        cod_invoice_limit:
          product.cod_invoice_limit !== undefined &&
          product.cod_invoice_limit !== null
            ? product.cod_invoice_limit
            : "",

        // Reverse / QC
        qc_enabled: qcEnabled,

        qc_charge:
          product.qc_charge !== undefined && product.qc_charge !== null
            ? product.qc_charge
            : "",

        qc_parameter_charge:
          product.qc_parameter_charge !== undefined &&
          product.qc_parameter_charge !== null
            ? product.qc_parameter_charge
            : "",

        error: {},
      });

      // -----------------------------------------------------
      // MODE RADIO
      // -----------------------------------------------------

      if (String(product.mode).toLowerCase() === "international") {
        setinternationalmodeState({
          international: true,
        });

        setdomesticmodeState({
          domestic: false,
        });
      } else {
        setdomesticmodeState({
          domestic: true,
        });

        setinternationalmodeState({
          international: false,
        });
      }

      // -----------------------------------------------------
      // PARCEL TYPE RADIO
      // -----------------------------------------------------

      if (String(product.parcel_type).toLowerCase() === "parcel") {
        setparceltypeState({
          parcel: true,
        });

        setdocumenttypeState({
          document: false,
        });
      } else {
        setparceltypeState({
          parcel: false,
        });

        setdocumenttypeState({
          document: true,
        });
      }

      // -----------------------------------------------------
      // ORDER TYPE RADIO
      // -----------------------------------------------------

      if (orderType === "Reverse") {
        setreversetypeState({
          reverse: true,
        });

        setforwardtypeState({
          forward: false,
        });
      } else {
        setforwardtypeState({
          forward: true,
        });

        setreversetypeState({
          reverse: false,
        });
      }

      setcarrierdetail({
        list: res.data.output,
      });
    } catch (error) {
      console.error("Product detail API error:", error);

      Toast.fire({
        background: "rgb(231, 91, 75)",
        icon: "error",
        title: "Unable to load product details",
        color: "white",
      });
    } finally {
      setLoading(false);
    }
  };

  // =========================================================
  // HANDLE COMMON CHANGE
  // =========================================================

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    const type = e.target.type;

    // -------------------------------------------------------
    // TEXT / NUMBER / SELECT
    // -------------------------------------------------------

    if (type === "text" || type === "number" || type === "select-one") {
      setState((prev) => ({
        ...prev,
        [name]: value,
      }));

      return;
    }

    // -------------------------------------------------------
    // RADIO
    // -------------------------------------------------------

    if (type === "radio") {
      if (!e.target.checked) {
        return;
      }

      // MODE
      if (name === "mode_domestic") {
        setdomesticmodeState({
          domestic: true,
        });

        setinternationalmodeState({
          international: false,
        });

        setState((prev) => ({
          ...prev,
          mode: "Domestic",
        }));

        return;
      }

      if (name === "mode_international") {
        setdomesticmodeState({
          domestic: false,
        });

        setinternationalmodeState({
          international: true,
        });

        setState((prev) => ({
          ...prev,
          mode: "International",
        }));

        return;
      }

      // PARCEL TYPE
      if (name === "document") {
        setparceltypeState({
          parcel: false,
        });

        setdocumenttypeState({
          document: true,
        });

        setState((prev) => ({
          ...prev,
          parcel_type: "Document",
        }));

        return;
      }

      if (name === "parcel") {
        setparceltypeState({
          parcel: true,
        });

        setdocumenttypeState({
          document: false,
        });

        setState((prev) => ({
          ...prev,
          parcel_type: "Parcel",
        }));

        return;
      }

      // ORDER TYPE - FORWARD
      if (name === "forward") {
        setforwardtypeState({
          forward: true,
        });

        setreversetypeState({
          reverse: false,
        });

        setState((prev) => ({
          ...prev,

          // IMPORTANT:
          // This must be order_type, not parcel_type.
          order_type: "Forward",

          // QC is not applicable for Forward
          qc_enabled: false,
          qc_charge: 0,
          qc_parameter_charge: 0,
        }));

        return;
      }

      // ORDER TYPE - REVERSE
      if (name === "reverse") {
        setreversetypeState({
          reverse: true,
        });

        setforwardtypeState({
          forward: false,
        });

        setState((prev) => ({
          ...prev,

          // IMPORTANT:
          // This must be order_type, not parcel_type.
          order_type: "Reverse",
        }));

        return;
      }
    }
  };

  // =========================================================
  // QC ENABLED CHANGE
  // =========================================================

  const handleQcChange = (enabled) => {
    if (enabled === true) {
      setState((prev) => ({
        ...prev,
        qc_enabled: true,
      }));

      return;
    }

    setState((prev) => ({
      ...prev,
      qc_enabled: false,
      qc_charge: 0,
      qc_parameter_charge: 0,
    }));
  };

  // =========================================================
  // PRODUCT TYPE CHANGE
  // =========================================================

  const handleChange1 = (e) => {
    setState((prev) => ({
      ...prev,
      product_type: e.target.value,
    }));
  };

  // =========================================================
  // SAVE PRODUCT
  // =========================================================

  const saveNewProduct = async () => {
    const errors = {};

    // -------------------------------------------------------
    // BASIC DETAILS
    // -------------------------------------------------------

    if (
      state.product_name === null ||
      state.product_name === undefined ||
      String(state.product_name).trim() === ""
    ) {
      errors.product_name = true;
    }

    if (state.mode === null || state.mode === undefined || state.mode === "") {
      errors.mode = true;
    }

    if (
      state.volumetric_weight === null ||
      state.volumetric_weight === undefined ||
      state.volumetric_weight === ""
    ) {
      errors.volumetric_weight = true;
    }

    if (
      state.max_weight === null ||
      state.max_weight === undefined ||
      state.max_weight === ""
    ) {
      errors.max_weight = true;
    }

    if (
      state.carrier_id === null ||
      state.carrier_id === undefined ||
      state.carrier_id === ""
    ) {
      errors.carrier_id = true;
    }

    if (
      state.parcel_type === null ||
      state.parcel_type === undefined ||
      state.parcel_type === ""
    ) {
      errors.parcel_type = true;
    }

    // -------------------------------------------------------
    // PRODUCT TYPE / SERVICE
    // -------------------------------------------------------

    if (producttype.length > 0) {
      if (
        state.product_type === null ||
        state.product_type === undefined ||
        state.product_type === ""
      ) {
        errors.product_type = true;
      }
    }

    // -------------------------------------------------------
    // FORWARD VALIDATION
    // -------------------------------------------------------

    if (state.order_type === "Forward") {
      if (
        state.cod_limit === null ||
        state.cod_limit === undefined ||
        state.cod_limit === ""
      ) {
        errors.cod_limit = true;
      }

      if (
        state.cod_invoice_limit === null ||
        state.cod_invoice_limit === undefined ||
        state.cod_invoice_limit === ""
      ) {
        errors.cod_invoice_limit = true;
      }

      if (Cod) {
        if (
          state.cod_percentage === null ||
          state.cod_percentage === undefined ||
          state.cod_percentage === ""
        ) {
          errors.cod_percentage = true;
        }

        if (
          state.cod_amount === null ||
          state.cod_amount === undefined ||
          state.cod_amount === ""
        ) {
          errors.cod_amount = true;
        }
      }
    }

    // -------------------------------------------------------
    // REVERSE / QC VALIDATION
    // -------------------------------------------------------

    if (state.order_type === "Reverse") {
      if (state.qc_enabled === true) {
        if (
          state.qc_charge === null ||
          state.qc_charge === undefined ||
          state.qc_charge === "" ||
          Number(state.qc_charge) <= 0
        ) {
          errors.qc_charge = true;
        }

        /*
         * Additional parameter charge can be 0.
         * The requirement says:
         *
         * fixed charge × number of QC parameters
         *
         * So 0 is technically a valid fixed charge.
         */
        if (
          state.qc_parameter_charge === null ||
          state.qc_parameter_charge === undefined ||
          state.qc_parameter_charge === "" ||
          Number(state.qc_parameter_charge) < 0
        ) {
          errors.qc_parameter_charge = true;
        }
      }
    }

    // -------------------------------------------------------
    // SET ERRORS
    // -------------------------------------------------------

    setState((prev) => ({
      ...prev,
      error: errors,
    }));

    if (Object.keys(errors).length > 0) {
      Toast.fire({
        background: "rgb(231, 91, 75)",
        icon: "error",
        title: "Please fill all the Details",
        color: "white",
      });

      return;
    }

    // -------------------------------------------------------
    // PREPARE QC VALUES
    // -------------------------------------------------------

    const isForward = state.order_type === "Forward";
    const isReverse = state.order_type === "Reverse";

    const qcEnabled = isReverse && state.qc_enabled === true;

    // -------------------------------------------------------
    // PREPARE API DATA
    // -------------------------------------------------------

    const sendData = {
      product_id: product_id,

      product_name: state.product_name,

      mode: state.mode,

      volumetric_weight: state.volumetric_weight,

      max_weight: state.max_weight,

      carrier_id: state.carrier_id,

      product_type: state.product_type,

      weight_range: rowstate,

      additional_weight: state.additional_weight,

      parcel_type: state.parcel_type,

      order_type: state.order_type,

      // ---------------------------------------------------
      // FORWARD / COD
      // ---------------------------------------------------

      cod_limit: isForward ? state.cod_limit : 0,

      cod_invoice_limit: isForward ? state.cod_invoice_limit : 0,

      ...(Cod
        ? {
            cod_percentage: isForward ? state.cod_percentage : 0,

            cod_amount: isForward ? state.cod_amount : 0,
          }
        : {}),

      // ---------------------------------------------------
      // REVERSE / QC
      // ---------------------------------------------------

      qc_enabled: qcEnabled,

      qc_charge: qcEnabled ? Number(state.qc_charge || 0) : 0,

      qc_parameter_charge: qcEnabled
        ? Number(state.qc_parameter_charge || 0)
        : 0,
    };

    console.log("Edit Product sendData:", sendData);

    try {
      setLoading(true);

      const full_api =
        exportValue.host +
        "/" +
        exportValue.version +
        "/" +
        exportValue.api +
        `/carrier_product_edit_api`;

      const res = await axios.post(full_api, sendData, {
        headers: exportValue.headers,
      });

      console.log("Edit Product response:", res);

      if (res.data?.status === true) {
        Toast.fire({
          background: "rgb(231, 91, 75)",
          icon: "success",
          title: "Updated Successfully",
          color: "white",
        });

        navigate("/product");
      } else {
        Toast.fire({
          background: "rgb(231, 91, 75)",
          icon: "error",
          title: res.data?.message || "Something Went Wrong",
          color: "white",
        });
      }
    } catch (error) {
      console.error("Edit Product API Error:", error);

      Toast.fire({
        background: "rgb(231, 91, 75)",
        icon: "error",
        title: "Something Went Wrong",
        color: "white",
      });
    } finally {
      setLoading(false);
    }
  };

  // =========================================================
  // RENDER ERROR
  // =========================================================

  const showError = (field) => {
    if (!state.error?.[field]) {
      return null;
    }

    return (
      <small
        style={{
          color: "rgb(167, 37, 20)",
          fontSize: "0.75rem",
          lineHeight: "1.66667",
          fontWeight: "400",
          letterSpacing: "0.05em",
        }}
      >
        Please fill this field
      </small>
    );
  };

  // =========================================================
  // PAGE
  // =========================================================

  return (
    <div>
      <Left_panel isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

      <section className="home-section">
        <Sub_header />

        {/* =================================================
            HEADER
        ================================================== */}

        <section>
          <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
            <div className="d-block mb-4 mb-md-0">
              <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
                <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
                  <li className="breadcrumb-item">
                    <a href="#">
                      <svg
                        className="icon icon-xxs"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0h6"
                        />
                      </svg>
                    </a>
                  </li>

                  <li className="breadcrumb-item active">Products</li>
                </ol>
              </nav>

              <h2 className="h4">Edit Product</h2>
            </div>
          </div>
        </section>

        {/* =================================================
            MAIN CONTENT
        ================================================== */}

        <section>
          <div className="row">
            {/* =================================================
                LEFT CARD
            ================================================== */}

            <div className="col-12 col-md">
              <div className="card h-100">
                <div className="card-body">
                  <h5>Setup Weight Range</h5>

                  <div className="add_product">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Start Range</th>
                          <th>End Range</th>
                        </tr>
                      </thead>

                      <tbody>
                        {rowstate.map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>

                            <td>
                              <input
                                type="number"
                                className="form-control"
                                placeholder="Enter Start Range"
                                name="start_range"
                                value={item.start_range}
                                disabled
                              />
                            </td>

                            <td>
                              <input
                                type="number"
                                className="form-control"
                                placeholder="Enter End Range"
                                name="end_range"
                                value={item.end_range}
                                disabled
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {/* =================================================
                      ADDITIONAL WEIGHT
                  ================================================== */}

                  <h5 className="mt-5">Additional Charges on Weight Upto</h5>

                  <div className="add_product">
                    <table className="table table-bordered">
                      <tbody>
                        <tr>
                          <td>
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Enter Weight"
                              name="additional_weight"
                              value={state.additional_weight}
                              disabled
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            {/* =================================================
                RIGHT CARD
            ================================================== */}

            <div className="col-12 col-md-4">
              <div className="card h-100">
                <div className="card-body">
                  {/* =================================================
                      PRODUCT NAME
                  ================================================== */}

                  <div className="mb-3 mt-3">
                    <label htmlFor="product_name" className="form-label">
                      Product Name:
                    </label>

                    <input
                      type="text"
                      className="form-control"
                      id="product_name"
                      placeholder="Enter Product Name"
                      name="product_name"
                      value={state.product_name}
                      onChange={handleChange}
                    />

                    {showError("product_name")}
                  </div>

                  {/* =================================================
                      MODE
                  ================================================== */}

                  <div className="mb-3 mt-3">
                    <label className="form-label">Mode:</label>

                    <br />

                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="mode_domestic"
                        id="edit_domestic"
                        value="Domestic"
                        onChange={handleChange}
                        checked={state.mode === "Domestic"}
                      />

                      <label
                        className="form-check-label"
                        htmlFor="edit_domestic"
                      >
                        Domestic Mode
                      </label>
                    </div>

                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="mode_international"
                        id="edit_international"
                        value="International"
                        onChange={handleChange}
                        checked={state.mode === "International"}
                      />

                      <label
                        className="form-check-label"
                        htmlFor="edit_international"
                      >
                        International Mode
                      </label>
                    </div>

                    {showError("mode")}
                  </div>

                  {/* =================================================
                      PARCEL TYPE
                  ================================================== */}

                  <div className="mb-3 mt-3">
                    <label className="form-label">Parcel Type:</label>

                    <br />

                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="document"
                        id="edit_document"
                        value="Document"
                        onChange={handleChange}
                        checked={state.parcel_type === "Document"}
                      />

                      <label
                        className="form-check-label"
                        htmlFor="edit_document"
                      >
                        Document
                      </label>
                    </div>

                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="parcel"
                        id="edit_parcel"
                        value="Parcel"
                        onChange={handleChange}
                        checked={state.parcel_type === "Parcel"}
                      />

                      <label className="form-check-label" htmlFor="edit_parcel">
                        Parcel
                      </label>
                    </div>

                    {showError("parcel_type")}
                  </div>

                  {/* =================================================
                      ORDER TYPE
                  ================================================== */}

                  <div className="mb-3 mt-3">
                    <label className="form-label">Order Type:</label>

                    <br />

                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="forward"
                        id="edit_forward"
                        value="Forward"
                        onChange={handleChange}
                        checked={state.order_type === "Forward"}
                      />

                      <label
                        className="form-check-label"
                        htmlFor="edit_forward"
                      >
                        Forward
                      </label>
                    </div>

                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="reverse"
                        id="edit_reverse"
                        value="Reverse"
                        onChange={handleChange}
                        checked={state.order_type === "Reverse"}
                      />

                      <label
                        className="form-check-label"
                        htmlFor="edit_reverse"
                      >
                        Reverse
                      </label>
                    </div>
                  </div>

                  {/* =================================================
                      CARRIER
                  ================================================== */}

                  <div className="mb-3 mt-3">
                    <label htmlFor="carrier_id" className="form-label">
                      Carrier:
                    </label>

                    <select
                      className="form-select"
                      name="carrier_id"
                      id="carrier_id"
                      value={state.carrier_id || carrier_id || ""}
                      disabled
                    >
                      <option value="">Select Carrier</option>

                      {carrierList.map((carrier) => (
                        <option
                          key={carrier.carrier_id}
                          value={carrier.carrier_id}
                        >
                          {carrier.carrier_name}
                        </option>
                      ))}
                    </select>

                    {showError("carrier_id")}
                  </div>

                  {/* =================================================
                      SERVICE
                  ================================================== */}

                  {producttype.length > 0 && (
                    <div className="mb-3 mt-3">
                      <label htmlFor="product_type" className="form-label">
                        Service:
                      </label>

                      <select
                        className="form-select"
                        name="product_type"
                        id="product_type"
                        onChange={handleChange1}
                        value={state.product_type}
                      >
                        <option value="">Select Product Type</option>

                        {producttype.map((item) => (
                          <option
                            key={item.product_type_id}
                            value={item.product_type_id}
                          >
                            {item.product_type_name}
                          </option>
                        ))}
                      </select>

                      {showError("product_type")}
                    </div>
                  )}

                  {/* =================================================
                      VOLUMETRIC WEIGHT
                  ================================================== */}

                  <div className="mb-4 mt-3">
                    <label htmlFor="volumetric_weight" className="form-label">
                      Volumetric weight:
                    </label>

                    <div className="input-group">
                      <span className="input-group-text">HxWxL /</span>

                      <input
                        type="number"
                        className="form-control"
                        placeholder="Volumetric Formula Rate"
                        name="volumetric_weight"
                        id="volumetric_weight"
                        onChange={handleChange}
                        value={state.volumetric_weight}
                      />
                    </div>

                    <div className="form-text">
                      Eg: Volumetric weight calculation HeightxWeightxLength /
                      5000
                    </div>

                    {showError("volumetric_weight")}
                  </div>

                  {/* =================================================
                      MAX WEIGHT
                  ================================================== */}

                  <div className="mb-3 mt-3">
                    <label htmlFor="max_weight" className="form-label">
                      Max Weight:
                    </label>

                    <input
                      type="number"
                      className="form-control"
                      id="max_weight"
                      placeholder="Enter Maximum Weight (KG)"
                      name="max_weight"
                      onChange={handleChange}
                      value={state.max_weight}
                    />

                    {showError("max_weight")}
                  </div>

                  {/* =================================================
                      FORWARD / COD SETTINGS
                  ================================================== */}

                  {state.order_type === "Forward" && (
                    <>
                      {/* COD LIMIT */}

                      <div className="mb-3 mt-3">
                        <label htmlFor="cod_limit" className="form-label">
                          COD Limit
                        </label>

                        <input
                          type="number"
                          className="form-control"
                          id="cod_limit"
                          placeholder="Enter COD limit"
                          name="cod_limit"
                          onChange={handleChange}
                          value={state.cod_limit}
                        />

                        {showError("cod_limit")}
                      </div>

                      {/* COD PERCENTAGE */}

                      {Cod ? (
                        <div className="mb-3 mt-3">
                          <label
                            htmlFor="cod_percentage"
                            className="form-label"
                          >
                            COD Commission in %
                          </label>

                          <input
                            type="number"
                            className="form-control"
                            id="cod_percentage"
                            placeholder="Enter COD commission percentage"
                            name="cod_percentage"
                            onChange={handleChange}
                            value={state.cod_percentage}
                          />

                          {showError("cod_percentage")}
                        </div>
                      ) : null}

                      {/* COD AMOUNT */}

                      {Cod ? (
                        <div className="mb-3 mt-3">
                          <label htmlFor="cod_amount" className="form-label">
                            COD Commission in Amount
                          </label>

                          <input
                            type="number"
                            className="form-control"
                            id="cod_amount"
                            placeholder="Enter COD commission amount"
                            name="cod_amount"
                            onChange={handleChange}
                            value={state.cod_amount}
                          />

                          {showError("cod_amount")}
                        </div>
                      ) : null}

                      {/* COD INVOICE LIMIT */}

                      <div className="mb-3 mt-3">
                        <label
                          htmlFor="cod_invoice_limit"
                          className="form-label"
                        >
                          COD Invoice Limit (X value)
                        </label>

                        <input
                          type="number"
                          className="form-control"
                          id="cod_invoice_limit"
                          placeholder="Enter X (e.g., 2000)"
                          name="cod_invoice_limit"
                          onChange={handleChange}
                          value={state.cod_invoice_limit}
                        />

                        <div className="form-text">
                          Example: If invoice value ≤ X, use first commission
                          slab.
                        </div>

                        {showError("cod_invoice_limit")}
                      </div>
                    </>
                  )}

                  {/* =================================================
                      REVERSE / QC SETTINGS
                  ================================================== */}

                  {state.order_type === "Reverse" && (
                    <>
                      {/* QC ENABLED */}

                      <div className="mb-3 mt-3">
                        <label className="form-label">
                          QC Enabled <span className="text-danger">*</span>
                        </label>

                        <br />

                        {/* YES */}

                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="qc_enabled"
                            id="edit_qc_yes"
                            checked={state.qc_enabled === true}
                            onChange={() => handleQcChange(true)}
                          />

                          <label
                            className="form-check-label"
                            htmlFor="edit_qc_yes"
                          >
                            Yes
                          </label>
                        </div>

                        {/* NO */}

                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="qc_enabled"
                            id="edit_qc_no"
                            checked={state.qc_enabled === false}
                            onChange={() => handleQcChange(false)}
                          />

                          <label
                            className="form-check-label"
                            htmlFor="edit_qc_no"
                          >
                            No
                          </label>
                        </div>
                      </div>

                      {/* =================================================
                          QC CHARGES
                      ================================================== */}

                      {state.qc_enabled === true && (
                        <>
                          {/* QC FIXED CHARGE */}

                          <div className="mb-3 mt-3">
                            <label htmlFor="qc_charge" className="form-label">
                              QC Charges (₹)
                              <span className="text-danger"> *</span>
                            </label>

                            <input
                              type="number"
                              min="0"
                              className="form-control"
                              id="qc_charge"
                              placeholder="Enter QC Charges"
                              name="qc_charge"
                              onChange={handleChange}
                              value={state.qc_charge}
                            />

                            <div className="form-text">
                              Fixed QC charge applied in addition to the normal
                              weight/zone freight charge.
                            </div>

                            {showError("qc_charge")}
                          </div>

                          {/* ADDITIONAL PARAMETER CHARGE */}

                          <div className="mb-3 mt-3">
                            <label
                              htmlFor="qc_parameter_charge"
                              className="form-label"
                            >
                              Additional Charge per QC Parameter (₹)
                              <span className="text-danger"> *</span>
                            </label>

                            <input
                              type="number"
                              min="0"
                              className="form-control"
                              id="qc_parameter_charge"
                              placeholder="Enter Additional Charge per QC Parameter"
                              name="qc_parameter_charge"
                              onChange={handleChange}
                              value={state.qc_parameter_charge}
                            />

                            <div className="form-text">
                              Fixed charge × number of QC parameters selected by
                              the seller.
                            </div>

                            {showError("qc_parameter_charge")}
                          </div>
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* =================================================
              SAVE
          ================================================== */}

          <div className="text-end mt-3">
            <button
              type="button"
              className="btn btn-primary btn-lg"
              onClick={saveNewProduct}
              disabled={loading}
            >
              {loading ? "Saving..." : "Save"}
            </button>
          </div>
        </section>
      </section>
    </div>
  );
};

export default Edit_product;
